import React from "react";
import './index.css';
import logo from '../images/把脉logo.png';
import logo1 from '../images/logo1.png';
import pattern3 from '../images/pattern3.png';
import example from '../images/example.png';
import bamboo from '../images/bamboo.png';
import pattern from '../images/pattern.png';
import logo2 from '../images/logo2.png';
import pulse from '../images/pulse.png';
import background1 from '../images/background1.png';
import pattern1 from '../images/pattern1.png';
import point from '../images/point.png';
import icon1 from '../images/icon1.png';
import icon2 from '../images/icon2.png';
import icon3 from '../images/icon3.png';

const IndexPage: React.FC = () => {
  return (
    <div className="website-container">
      {/* 顶部tab */}
      <header className="header">
        <div className="header-content">
          <img src={logo} alt="知源把脉养生" className="logo-image" />
          <div className="logo-text">知源把脉养生</div>
        </div>
      </header>
      {/* 内容区 */}
      <main className="main-content">
        <div className="main-left-content">
          <img src={logo1} alt="logo1" className="main-logo1" />
          <div className="pulse-test">脉象一键测</div>
          <div className="health-analysis">健康分析｜饮食建议随时看</div>
          <img src={pattern3} alt="pattern3" className="main-pattern3" />
          <div className="philosophy-text">
            <div className="vertical-divider"></div>
            <span>精神内守</span>
            <div className="vertical-divider"></div>
            <span>恬淡虚无</span>
            <div className="vertical-divider"></div>
            <span>邪不可干</span>
            <div className="vertical-divider"></div>
            <span>正气存内</span>
            <div className="vertical-divider"></div>
          </div>
        </div>
        <img src={example} alt="example" className="main-example" />
        <div className="bottom-content">
          <img src={bamboo} alt="bamboo" className="bamboo-image" />
          <img src={logo2} alt="logo2" className="logo2-image" />
          <div className="pulse-background">
            <img src={pulse} alt="pulse" className="pulse-image" />
            <img src={background1} alt="background1" className="background1-image" />
          </div>
          <div className="pulse-text">
            <p>随时查看您的</p>
            <p>【脉象记录】</p>
            <p>和获取最新的健康建议</p>
          </div>
          <img src={pattern1} alt="pattern1" className="pattern1-image" />
          <div className="dietary-advice-section">
            <div className="dietary-item">
              <img src={point} alt="point" className="point-image" />
              <div className="dietary-text-container">
                <span className="dietary-english">DIETARY ADVICE</span>
                <span className="dietary-chinese">饮食建议</span>
              </div>
              <img src={icon1} alt="icon1" className="icon-image" />
            </div>
            <div className="dietary-item">
              <img src={point} alt="point" className="point-image" />
              <div className="dietary-text-container">
                <span className="dietary-english">PULSE CONDITIONS AND PRECAUTIONS</span>
                <span className="dietary-chinese">脉象宜忌</span>
              </div>
              <img src={icon2} alt="icon2" className="icon-image" />
            </div>
            <div className="dietary-item">
              <img src={point} alt="point" className="point-image" />
              <div className="dietary-text-container">
                <span className="dietary-english">TWENTY-FOUR HOURS</span>
                <span className="dietary-chinese">二十四时辰</span>
              </div>
              <img src={icon3} alt="icon3" className="icon-image" />
            </div>
          </div>
          <img src={pattern} alt="pattern" className="pattern-image" />
        </div>
      </main>
      {/* 底部 */}
      <footer className="footer">
        <div className="footer-info">
          <p><strong>电话: </strong>4000739008</p>
          <p><strong>邮箱: </strong>zhiyuanAI@nineton.cn</p>
          <p><strong>联系地址: </strong>重庆市渝北区洪湖西路24号B栋11楼</p>
        </div>
        <div className="footer-bottom">
          <span>https://health.zhi-yuan.net | All rights reserved. © 2021-2025 | 重庆知源健康管理有限公司 | <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'white',
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
          >
            渝ICP备2021007722号-6
          </a> | 互联网药品信息服务资格证书：(渝)-经营性-2023-0019</span>
        </div>
      </footer>
    </div>
  );
};

export default IndexPage;